import React, { useState } from "react";
import { toast } from "sonner";
import { api, apiErr } from "@/lib/api";
import { Badge } from "@/lib/ui";

export async function downloadBlob(url, params, filename) {
  const { data } = await api.get(url, { params, responseType: "blob" });
  const href = URL.createObjectURL(data);
  const a = document.createElement("a"); a.href = href; a.download = filename; a.click();
  URL.revokeObjectURL(href);
}

export function PrivateImage({ url, alt, className, testid }) {
  const [src, setSrc] = useState(null);
  const [err, setErr] = useState(false);
  React.useEffect(() => {
    let obj;
    api.get(url, { responseType: "blob" }).then(({ data }) => { obj = URL.createObjectURL(data); setSrc(obj); }).catch(() => setErr(true));
    return () => obj && URL.revokeObjectURL(obj);
  }, [url]);
  if (err) return <span className="text-xs text-slate-400">Not available</span>;
  return src ? <img src={src} alt={alt} className={className} data-testid={testid} /> : <span className="text-xs text-slate-400">Loading…</span>;
}

export function ScreenshotButton({ txnId }) {
  const [src, setSrc] = useState(null);
  const open = async () => {
    try {
      const { data } = await api.get(`/referor-files/${txnId}`, { responseType: "blob" });
      setSrc({ url: URL.createObjectURL(data), pdf: data.type === "application/pdf" });
    } catch (e) { toast.error(apiErr(e)); }
  };
  return (
    <>
      <button onClick={open} data-testid={`screenshot-${txnId}`} className="text-xs font-semibold text-orange-700 underline"><i className="fa-solid fa-image mr-1" />View</button>
      {src && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 p-4" onClick={() => setSrc(null)}>
          <div className="max-h-full max-w-3xl overflow-auto rounded-2xl bg-white p-3" onClick={(e) => e.stopPropagation()}>
            <div className="mb-2 flex items-center justify-between gap-6 text-sm"><b>Payment proof · {txnId}</b>
              <span className="flex items-center gap-4"><a href={src.url} download={`${txnId}-proof`} className="text-orange-700 underline">Download</a><button onClick={() => setSrc(null)} className="px-1"><i className="fa-solid fa-xmark" /></button></span></div>
            {src.pdf ? <iframe title="proof" src={src.url} className="h-[70vh] w-[80vw] max-w-3xl" /> : <img src={src.url} alt="proof" className="max-h-[75vh] rounded-lg" />}
          </div>
        </div>
      )}
    </>
  );
}

export const StatusBadge = ({ s }) => <Badge tone={s === "paid" || s === "approved" || s === "converted" ? "emeraldSoft" : s === "reversed" || s === "rejected" || s === "failed" ? "red" : s === "pending" ? "amber" : "slate"}>{s}</Badge>;
